import React from "react";
import { CheckCircle, Star } from "lucide-react";
import { testimonials, caseStudies } from "../../data/homepageData";

export const ProofSection = () => (
  <section id="proof" className="py-20">
    <div className="mx-auto max-w-7xl px-6">
      <div className="mb-16">
        <div className="text-center mb-4">
          <h2 className="text-3xl md:text-4xl font-bold">
            What Our
            <span className="text-green-400"> Clients Say</span>
          </h2>
          <p className="mt-4 text-slate-400">
            Illustrative examples reflecting individual client feedback. Names changed for privacy.
          </p>
          <p className="mt-2 text-xs text-slate-500 max-w-2xl mx-auto">
            Individual experiences. Not typical or guaranteed outcomes. We do not control platform decisions.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-8">
          {testimonials.map((t) => (
            <div key={t.id} className="rounded-2xl border border-white/10 bg-white/5 p-6">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              <p className="text-slate-300 leading-relaxed mb-4">&ldquo;{t.quote}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-sm">{t.author}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
                <span className="px-2 py-1 rounded bg-white/10 text-xs text-slate-400">
                  {t.platform}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold">Types of Cases We Prepare Documentation For</h3>
          <p className="mt-2 text-slate-400 text-sm">
            Illustrative examples of the case types and documentation work we handle.
            Outcomes are determined by each platform and are not guaranteed.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {caseStudies.map((study) => (
            <div key={study.id} className="rounded-2xl border border-slate-500/20 bg-slate-500/5 p-6">
              <div className="flex items-center justify-between mb-4">
                <span className="px-3 py-1 rounded-full bg-white/10 text-sm font-medium">
                  {study.platform}
                </span>
                <CheckCircle className="w-5 h-5 text-slate-300" />
              </div>
              <p className="text-slate-300 font-medium mb-2">{study.issue}</p>
              <p className="text-slate-400 text-sm mb-3">{study.timeline}</p>
              <p className="text-slate-300 text-sm">{study.outcome}</p>
            </div>
          ))}
        </div>
        <p className="mt-6 text-center text-xs text-slate-500 max-w-2xl mx-auto">
          These examples describe the documentation work we prepare and submit. Actual platform decisions,
          timelines, and outcomes vary and are outside our control.
        </p>
      </div>
    </div>
  </section>
);
